import React, { useState, useContext, useEffect, useRef } from 'react';
import { TableContext } from '../context';
import '../App.css';
import {
    Dialog,
    DialogContent,
    IconButton,
    Button,
    Checkbox,
    FormControlLabel,
    FormGroup,
    CircularProgress
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import axios from 'axios';

const MySubscriptions = () => {
    const { mySubscriptionsOpen, setMySubscriptionsOpen, subscriptions, graphData, getSubscriptions,getToken } = useContext(TableContext);
    const [selectedUnsubscribeApps, setSelectedUnsubscribeApps] = useState([]);

    const handleDialogClose = () => {
        setSelectedUnsubscribeApps([]); // Clear selected apps
        setMySubscriptionsOpen(false); // Closes the popup
    };

    const handleCheckboxChange = (app) => {
      setSelectedUnsubscribeApps((prevSelectedApps) =>
          prevSelectedApps.includes(app)
              ? prevSelectedApps.filter((selectedApp) => selectedApp !== app)
              : [...prevSelectedApps, app]
      );
    };

    const handleUnsubscribeClick = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URI}/api/subscription/unsubscribe`,
          {
            user_email: graphData?.mail,
            app_name: selectedUnsubscribeApps,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("jwt_token"),
            }
          }
        );
        
        if (response.data.status === 200) {
          handleDialogClose();
          getSubscriptions();
          toast.success("Application(s) Unsubscribed successfully", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
          });
        } else {
            handleDialogClose();
            console.error('Failed to Unsubscribe to Application(s)');
            toast.error("Failed to Unsubscribe to Application(s)", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
          });
        }
      } catch (error) {
        handleDialogClose();
        console.error(error);
        toast.error("Failed to Unsubscribe to Application(s)", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
      });
      }
    };

    return(
        <Dialog 
          open={mySubscriptionsOpen} 
          onClose={handleDialogClose} 
          maxWidth="sm" 
          fullWidth
        >
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleDialogClose}
              aria-label="close"
              style={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent>
                <>
                  {subscriptions.length > 0 ? (
                    <div>
                      <h2>My Subscriptions</h2>
                      <FormGroup style={{marginTop: '10px', maxHeight: "300px", overflowY: "auto", display: 'block'}}>
                          {subscriptions.map((app) => (
                              <FormControlLabel
                                  key={app.trim()}
                                  control={
                                      <Checkbox
                                          checked={selectedUnsubscribeApps.includes(app.trim())}
                                          onChange={() => handleCheckboxChange(app.trim())}
                                          sx={{
                                              color: '#141414',
                                              '&.Mui-checked': {
                                                  color: '#141414',
                                              },
                                          }}
                                      />
                                  }
                                  label={app.trim()}
                                  style={{ display: 'block' }}
                              />
                          ))}
                      </FormGroup>
                      <button
                        onClick={() => toast.promise(handleUnsubscribeClick(), {
                          pending: "Unsubscribing...",
                        })}
                        className="animated-search-button"
                        disabled={selectedUnsubscribeApps.length === 0}
                        style={{
                            marginTop: '16px',
                            marginLeft: '440px',
                            backgroundColor: selectedUnsubscribeApps.length !== 0 && '#FA6A55'
                          }}
                      >
                        Unsubscribe
                      </button>
                    </div>
                  ) : (
                    <div style={{ textAlign: 'center', margin: '20px' }}>
                        <p>No subscriptions available.</p>
                    </div>
                  )}
                </>
            </DialogContent>
        </Dialog>
    );
}

export default MySubscriptions;